import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorCheckAttachmentStatusService } from '../../api/ai-creator'
import { aICreatorCheckAttachmentStatusSuccess } from '../../reducers/ai-creator/action'
import { CHECK_ATTACHMENT_STATUS_AI_CREATOR } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* checkAttachmentStatusFlow(payload) {
  try {
    const { attachmentId, callback } = payload

    const response = yield call(
      AICreatorCheckAttachmentStatusService,
      attachmentId,
    )

    yield put(aICreatorCheckAttachmentStatusSuccess(response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* aICreatorCheckAttachmentStatusWatcher() {
  while (true) {
    const action = yield take(CHECK_ATTACHMENT_STATUS_AI_CREATOR)
    const { payload } = action

    yield fork(generalSaga, checkAttachmentStatusFlow, payload, false)
  }
}
